import {
  PriceDTO,
  ProductDTO,
  ProductDetailDTO,
} from "@campgladiator/cg-common.types.types";

export const prices: PriceDTO[] = [
  {
    active: true,
    amount: 2900,
    created: "",
    currency: "USD",
    deleted: true,
    description: "",
    id: "1",
    lastUpdated: "",
    name: "test",
    productId: "1",
    stripePriceId: "1",
    stripeProductId: "1",
    term: "MONTH",
    termLength: 1,
    type: "",
  },
  {
    active: true,
    amount: 3900,
    created: "",
    currency: "USD",
    deleted: false,
    description: "",
    id: "1",
    lastUpdated: "",
    name: "test",
    productId: "1",
    stripePriceId: "1",
    stripeProductId: "1",
    term: "MONTH",
    termLength: 2,
    type: "",
  },
  {
    active: false,
    amount: 2300,
    created: "",
    currency: "USD",
    deleted: false,
    description: "",
    id: "1",
    lastUpdated: "",
    name: "test",
    productId: "1",
    stripePriceId: "1",
    stripeProductId: "1",
    term: "MONTH",
    termLength: 3,
    type: "",
  },
];

export const products: ProductDTO[] = [
  {
    active: true,
    created: "",
    deleted: false,
    id: "00",
    lastUpdated: "",
    prices,
    stripeProductDescription: "",
    stripeProductId: "product1",
    stripeProductName: "1 month camp",
    termLength: 1,
    subType: "IN_PERSON",
    type: "BOOTCAMP",
  },
  {
    active: true,
    created: "",
    deleted: false,
    id: "01",
    lastUpdated: "",
    prices,
    stripeProductDescription: "",
    stripeProductId: "product2",
    stripeProductName: "6 month camp",
    termLength: 6,
    subType: "IN_PERSON",
    type: "BOOTCAMP",
  },
  {
    active: true,
    created: "",
    deleted: false,
    id: "02",
    lastUpdated: "",
    prices,
    stripeProductDescription: "",
    stripeProductId: "product3",
    stripeProductName: "12 month camp",
    termLength: 12,
    subType: "IN_PERSON",
    type: "BOOTCAMP",
  },
  {
    active: true,
    created: "",
    deleted: false,
    id: "03",
    lastUpdated: "",
    prices,
    stripeProductDescription: "",
    stripeProductId: "product4",
    stripeProductName: "24 month camp",
    termLength: 24,
    subType: "IN_PERSON",
    type: "BOOTCAMP",
  },
  {
    active: false,
    created: "",
    deleted: false,
    id: "04",
    lastUpdated: "",
    prices,
    stripeProductDescription: "",
    stripeProductId: "product5",
    stripeProductName: "36 month camp",
    termLength: 36,
    subType: "IN_PERSON",
    type: "BOOTCAMP",
  },
];

export const membership: ProductDetailDTO[] = [
  {
    approvalRequired: "OUTDOOR",
    created: "",
    deleted: false,
    id: "1",
    image: "",
    lastUpdated: "",
    miniatureImage: "",
    overview: "",
    sellingPoints: [],
    subType: "IN_PERSON",
    title: "In person Camp",
    type: "BOOTCAMP",
    products,
  },
];

export const productDetails: ProductDetailDTO = {
  id: "b0f53956-021c-4309-82f7-82f82201a01f",
  type: "BOOTCAMP",
  subType: "IN_PERSON",
  title: "Outdoor & Online Camp",
  sellingPoints: [
    "Full body cardio training",
    "Unlimited access to Outdoor and Online Camp workouts",
    "Group fitness for all levels with expert coaching & community 1",
  ],
  overview:
    "Outdoor full body training with in-person coaching and fitness community.",
  image:
    "https://storage.googleapis.com/stage.wl4cg.com/images/products/product_outdoor_online.png",
  miniatureImage:
    "https://storage.googleapis.com/stage.wl4cg.com/images/products/outdooor%26onlineIcon.png",
  approvalRequired: "OUTDOOR",
  created: "2022-10-18T21:35:30.207326Z",
  lastUpdated: "2023-04-25T15:07:15.023537Z",
  deleted: false,
  products: [
    {
      id: "01bcbe10-1d37-4d88-8e45-c793a51393f0",
      stripeProductId: "prod_NWJLE0Sg2E1ejR",
      stripeProductName: "Outdoor & Online Camp: 24 Months Membership",
      stripeProductDescription: "24 Months minimum commitment.",
      active: true,
      termLength: 24,
      subType: "IN_PERSON",
      type: "BOOTCAMP",
      prices: [
        {
          id: "566c2439-fe4f-4ad2-ab8a-954872d26156",
          productId: "01bcbe10-1d37-4d88-8e45-c793a51393f0",
          stripeProductId: "prod_NWJLE0Sg2E1ejR",
          stripePriceId: "price_1MlGkwJWDZbdRfZoujDWdIut",
          name: "24 Months",
          description: "24 Months Minimum Commitment",
          amount: 5900,
          currency: "usd",
          type: "RECURRING",
          termLength: 1,
          term: "MONTH",
          active: true,
          created: "2023-03-13T19:10:48.92987Z",
          lastUpdated: "2023-03-13T19:10:48.929887Z",
          deleted: false,
        },
      ],
      created: "2023-03-13T19:09:14.512434Z",
      lastUpdated: "2023-03-13T19:09:14.512465Z",
      deleted: false,
    },
    {
      id: "e796843b-a88d-4d5a-85e8-9a4673b8d746",
      stripeProductId: "prod_NWJE4TXRRrQ7x6",
      stripeProductName: "Outdoor & Online Camp: 12 Months Membership",
      stripeProductDescription: "12 Months minimum commitment.",
      active: true,
      termLength: 12,
      subType: "IN_PERSON",
      type: "BOOTCAMP",
      prices: [
        {
          id: "7fb355ee-d2e0-4a0b-8c46-faabd803516e",
          productId: "e796843b-a88d-4d5a-85e8-9a4673b8d746",
          stripeProductId: "prod_NWJE4TXRRrQ7x6",
          stripePriceId: "price_1MlGevJWDZbdRfZoeQtmoZGJ",
          name: "12 Months",
          description: "12 Months Minimum Commitment",
          amount: 6900,
          currency: "usd",
          type: "RECURRING",
          termLength: 1,
          term: "MONTH",
          active: true,
          created: "2023-03-13T19:06:13.265123Z",
          lastUpdated: "2023-03-13T19:06:13.265141Z",
          deleted: false,
        },
      ],
      created: "2023-03-13T19:03:15.295376Z",
      lastUpdated: "2023-03-13T19:03:15.295398Z",
      deleted: false,
    },
    {
      id: "27f68389-5f3a-458b-a2f6-1982bf117bc2",
      stripeProductId: "prod_NWJ89W9AqFXq6T",
      stripeProductName: "Outdoor & Online Camp: 6 Months Membership",
      stripeProductDescription: "6 Months minimum commitment.",
      active: true,
      termLength: 6,
      subType: "IN_PERSON",
      type: "BOOTCAMP",
      prices: [
        {
          id: "a7a69876-8f8e-4bb4-ab6a-da5465242c73",
          productId: "27f68389-5f3a-458b-a2f6-1982bf117bc2",
          stripeProductId: "prod_NWJ89W9AqFXq6T",
          stripePriceId: "price_1MlGXMJWDZbdRfZozfEafgHn",
          name: "6 Months",
          description: "6 Months Minimum Commitment",
          amount: 8900,
          currency: "usd",
          type: "RECURRING",
          termLength: 1,
          term: "MONTH",
          active: true,
          created: "2023-03-13T18:56:36.114711Z",
          lastUpdated: "2023-03-13T18:56:36.114729Z",
          deleted: false,
        },
      ],
      created: "2023-03-13T18:55:37.805258Z",
      lastUpdated: "2023-03-13T18:55:37.805276Z",
      deleted: false,
    },
    {
      id: "50c2cd2d-151c-4cb8-93e9-da266b862ae7",
      stripeProductId: "prod_NWJ1TLeU7PYGzi",
      stripeProductName: "Outdoor & Online Camp: Month to month Membership",
      stripeProductDescription: "No minimum commitment.",
      active: true,
      termLength: 1,
      subType: "IN_PERSON",
      type: "BOOTCAMP",
      prices: [
        {
          id: "6bb94fc2-3798-4978-afe7-4275bb1f906b",
          productId: "50c2cd2d-151c-4cb8-93e9-da266b862ae7",
          stripeProductId: "prod_NWJ1TLeU7PYGzi",
          stripePriceId: "price_1MlGT7JWDZbdRfZo1Hq9e9bG",
          name: "Month-to-month",
          description: "No Minimum Commitment",
          amount: 9900,
          currency: "usd",
          type: "RECURRING",
          termLength: 1,
          term: "MONTH",
          active: true,
          created: "2023-03-13T18:52:12.562762Z",
          lastUpdated: "2023-03-13T18:52:12.562781Z",
          deleted: false,
        },
      ],
      created: "2023-03-13T18:48:30.971579Z",
      lastUpdated: "2023-03-13T18:48:30.971603Z",
      deleted: false,
    },
    {
      id: "6d2e3c6f-42b9-41e5-89c5-cd03ec8b46a5",
      stripeProductId: "prod_Q7PCFWM7EqWOpi",
      stripeProductName: "BOLD+: 3 Months Membership",
      stripeProductDescription: "3 Months no commitment",
      active: true,
      termLength: 3,
      subType: "IN_PERSON",
      type: "BOOTCAMP",
      prices: [
        {
          id: "182c1fbf-930d-43ec-9029-4c07c5c935e0",
          productId: "6d2e3c6f-42b9-41e5-89c5-cd03ec8b46a5",
          stripeProductId: "prod_Q7PCFWM7EqWOpi",
          stripePriceId: "price_1PIxrSJWDZbdRfZolggM4kQV",
          name: "3 Months",
          description: "3 months without auto-renewal",
          amount: 31800,
          currency: "usd",
          type: "ONE_TIME",
          termLength: 3,
          term: "MONTH",
          active: true,
          created: "2024-05-16T19:59:12.023399Z",
          lastUpdated: "2024-05-16T19:59:12.023428Z",
          deleted: false,
        },
      ],
      created: "2023-03-13T18:48:30.971579Z",
      lastUpdated: "2023-03-13T18:48:30.971603Z",
      deleted: false,
    },
  ],
};
